import { render, staticRenderFns } from "./tiyouyouStudentList.vue?vue&type=template&id=7a9ff920&"
import script from "./tiyouyouStudentList.vue?vue&type=script&lang=js&"
export * from "./tiyouyouStudentList.vue?vue&type=script&lang=js&"
import style0 from "./tiyouyouStudentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports